<template>
  <ModalSide
    :state="state"
    :open="open"
    :close="onClose"
    :persistent="!GLOBAL.isEmpty(haveDiff)"
  >
    <template #content>
      <q-form class="flex flex-col flex-1 h-[calc(100vh_-_64px)]">
        <div class="flex-1 overflow-auto">
          <div class="p-24 ">
            <template v-for="item in relation" :key="item.label">
              <OFormField class="pb-16">
                <OLabel class="text-pararaphy-2 text-black">
                  {{ item.label }}
                </OLabel>
                <OInput v-model="item.model" readonly size="md" :type="item.type"  />
              </OFormField>
            </template>
          </div>
        </div>

        <div class="flex flex-row-reverse gap-8 shrink-0 p-24">
          <OButton
            size="md"
            class="w-[169px] h-[44px] bg-primary-pure rounded-lg"
            color=""
            label="Salvar alterações"
            :disable="!haveDiff"
            @click="onSave"
          />

          <OButton
            size="md"
            secondary
            class="w-[108px] h-[44px] rounded-lg"
            color="primary-pure"
            label="Cancelar"
            @click="onClose"
          />
        </div>
      </q-form>
    </template>
  </ModalSide>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { errorDefault } from 'js/utils/error'
import { i18n } from 'js/vue/i18n'
import { NotifyError, NotifySucess } from 'js/vue/boot/Notify'
import { parametrosService } from 'js/vue/services/parametros.service'
import { useI18n } from 'vue-i18n'
import GLOBAL from 'js/utils/GLOBAL'
import HeaderModalBase from 'components/Header/HeaderModalBase.vue'
import ModalSide from './ModalSide.vue'
import OButton from 'components/Button/OButton.vue'
import OFormField from 'components/Field/OFormField.vue'
import OInput from 'components/Input/OInput.vue'
import OLabel from 'components/Label/OLabel.vue'
import useModal from 'composables/useModal'

const { t, locale } = useI18n()

const modalParametros = useModal()

const { state, open, close } = modalParametros

const text = ref('')

defineExpose({
  ...modalParametros,
})

const { getParametros, patchParametros } = parametrosService()

const relation = computed(() => ({
  pais: { label: t('parameters.country'), mask: null, model: null, type:'text' },
  cliente: { label: t('parameters.client'), mask: null, model: null, type:'text' },
  canal: { label: t('parameters.channel'), mask: null, model: null, type:'text' },
  subcanal: { label: t('parameters.subchannel'), mask: null, model: null, type:'text' },
  canal_ko: { label: t('parameters.channel_ko'), mask: null, model: null, type:'text' },
  nome: { label: t('parameters.name'), mask: null, model: null, type:'text' },
  nome_extenso: { label: t('parameters.full_name'), mask: null, model: null, type:'text' },
  rua: { label: t('parameters.street'), mask: null, model: null, type:'text' },
  ext_id: { label: t('parameters.ext_id'), mask: null, model: null, type:'text' },
  man_id: { label: t('parameters.man_id'), mask: null, model: null, type:'number' },
  id_uf: { label: t('parameters.state_id'), mask: null, model: null, type:'number' },
  id_municipio: { label: t('parameters.city_id'), mask: null, model: null, type:'number' },
  id_local: { label: t('parameters.local_id'), mask: null, model: null, type:'number' },
  nome_unidade_federativa: {  label: t('parameters.state_name'), mask: null, model: null, type:'text',
  },
  nome_municipio: { label: t('parameters.city_name'), mask: null, model: null, type:'text' },
  nome_local: { label: t('parameters.local_name'), mask: null, model: null, type:'text' },
  categoria: { label: t('parameters.category'), mask: null, model: null, type:'text' },
  industria: { label: t('parameters.industry'), mask: null, model: null, type:'text' },
  website: { label: t('parameters.website'), mask: null, model: null, type:'text' },
  latitude: { label: t('parameters.latitude'), mask: null, model: null, type:'number' },
  longitude: { label: t('parameters.longitude'), mask: null, model: null, type:'number' },
  ano: { label: t('parameters.year'), mask: null, model: null, type:'number',  },
  mes: { label: t('parameters.month'), mask: null, model: null, type:'number',  },
}))

const oldResult = ref(relation.value)

const haveDiff = computed(() =>
  GLOBAL.compareAndReturnDiff(oldResult.value, relation.value)
)

const id = ref(null)
async function requests() {
  const { results } = await getParametros()
  const params = results.at()

  Object.entries(params).forEach(([key, value]) => {
    if (relation.value[key]) {
      relation.value[key].model = value
    }
  })

  id.value = params.id

  oldResult.value = JSON.parse(JSON.stringify(relation.value))
}

function onClose() {
  relation.value = JSON.parse(JSON.stringify(oldResult.value))
  close()
}

async function onSave() {
  try {
    const data = Object.entries(haveDiff.value) //
      .reduce((acc, [key, value]) => {
        acc[key] = value.model
        return acc
      }, {})
    const result = await patchParametros(id.value, data)
    oldResult.value = JSON.parse(JSON.stringify(relation.value))
    NotifySucess("Salvo com sucesso")
  } catch (error) {
    errorDefault('Ocorreu um erro ao Salvar', error)
  }

}

watch(
 () => i18n.global.availableLocales.includes(locale.value),
 () => {
   modalParametros.setState({
     header: { title: t('quickAcess.parameter.title') },
   })
 },
 { immediate: true }
)

onMounted(() => {
  requests()
})
</script>

<style lang="scss" scoped></style>
